// Shared priority chip — one source of truth for priority colors/labels.
import React from 'react';
import { Chip } from '@mui/material';

export const PRIORITY_LEVELS = ['Low', 'Medium', 'High', 'Urgent'];

const PRIORITY_COLORS = {
  Low: 'default',
  Medium: 'info',
  High: 'warning',
  Urgent: 'error',
};

// Old complaints predate the priority field — treat missing as Medium.
export const normalizePriority = (priority) =>
  PRIORITY_LEVELS.includes(priority) ? priority : 'Medium';

const PriorityChip = ({ priority, size = 'small', ...props }) => {
  const value = normalizePriority(priority);
  return (
    <Chip
      label={value}
      color={PRIORITY_COLORS[value]}
      size={size}
      variant={value === 'Low' ? 'outlined' : 'filled'}
      {...props}
    />
  );
};

export default PriorityChip;
